var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ModulationBoxAdapter_terminator, _ModulationBoxAdapter_context, _ModulationBoxAdapter_box, _ModulationBoxAdapter_parametric;
import { StringMapping, Terminable, Terminator, ValueMapping } from "@opendaw/lib-std";
import { ParameterAdapterSet } from "../ParameterAdapterSet";
import { isModulatorBoxAdapter } from "./ModulatorBoxAdapter";
import { ParameterOwner } from "../ParameterOwner";
export class ModulationBoxAdapter {
    constructor(context, box) {
        _ModulationBoxAdapter_terminator.set(this, new Terminator());
        _ModulationBoxAdapter_context.set(this, void 0);
        _ModulationBoxAdapter_box.set(this, void 0);
        _ModulationBoxAdapter_parametric.set(this, void 0);
        __classPrivateFieldSet(this, _ModulationBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _ModulationBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _ModulationBoxAdapter_parametric, __classPrivateFieldGet(this, _ModulationBoxAdapter_terminator, "f").own(new ParameterAdapterSet(__classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f"))), "f");
        this.namedParameter = {
            depth: __classPrivateFieldGet(this, _ModulationBoxAdapter_parametric, "f").createParameter(box.depth, ValueMapping.bipolar(), StringMapping.percent({ fractionDigits: 0 }), "Depth", 0.5)
        };
        // The depth's automation lane lives on the modulator that drives it, so it shows up in that group.
        const registration = __classPrivateFieldGet(this, _ModulationBoxAdapter_terminator, "f").own(new Terminator());
        __classPrivateFieldGet(this, _ModulationBoxAdapter_terminator, "f").own(box.source.catchupAndSubscribe(() => {
            registration.terminate();
            box.source.targetVertex
                .flatMap(vertex => __classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f").boxAdapters.optAdapter(vertex.box))
                .ifSome(adapter => {
                if (isModulatorBoxAdapter(adapter)) {
                    registration.own(this.namedParameter.depth.registerTracks(adapter.tracks));
                }
            });
        }));
    }
    get box() { return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").address; }
    get enabled() { return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").enabled.getValue(); }
    get depth() { return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").depth.getValue(); }
    get source() {
        return __classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f").boxAdapters.adapterFor(__classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").source.targetVertex.unwrap("no modulator").box, isModulatorBoxAdapter);
    }
    /// `None` while the target field has no registered parameter adapter yet.
    get target() {
        return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").target.targetVertex
            .flatMap(vertex => __classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f").parameterFieldAdapters.opt(vertex.address));
    }
    get targetAudioUnit() {
        return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").target.targetVertex.flatMap(vertex => ParameterOwner.audioUnitOf(__classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f"), vertex));
    }
    get targetOwner() {
        return __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").target.targetVertex.flatMap(vertex => ParameterOwner.nameOf(__classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f"), vertex));
    }
    /// The owner's name, kept current: renaming the device the target belongs to notifies again.
    catchupAndSubscribeTargetOwner(observer) {
        const vertex = __classPrivateFieldGet(this, _ModulationBoxAdapter_box, "f").target.targetVertex;
        if (vertex.isEmpty()) {
            observer("");
            return Terminable.Empty;
        }
        return ParameterOwner.catchupAndSubscribeName(__classPrivateFieldGet(this, _ModulationBoxAdapter_context, "f"), vertex.unwrap(), observer);
    }
    terminate() { __classPrivateFieldGet(this, _ModulationBoxAdapter_terminator, "f").terminate(); }
}
_ModulationBoxAdapter_terminator = new WeakMap(), _ModulationBoxAdapter_context = new WeakMap(), _ModulationBoxAdapter_box = new WeakMap(), _ModulationBoxAdapter_parametric = new WeakMap();
